import React from 'react';
import PropTypes from 'prop-types';
import HardSkillProp from '../../../challenges/propTypes/hardSkillProp';
import HardSkillsIcon from '../../sidePanel/icons/HardSkillsIcon';

export default function HardSkillItem({ hardSkill, onRemove }) {
  const { skillLevel, name, _id } = hardSkill;
  const { icon, name: levelName } = skillLevel || {};

  return (
    <div className="hard-skill-item">
      <div className="hard-skill-image">
        {icon ? (
          <img className="img-icon" src={icon} alt="hard-skill level" />
        ) : (
          <HardSkillsIcon />
        )}
      </div>
      <span className="hard-skill-name">{name}</span>
      <span className="hard-skill-level">{levelName}</span>
      <button
        type="button"
        className="btn btn-metal m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill hard-skill-remove"
        onClick={() => onRemove(_id)}
      >
        <i className="fa fa-times" />
      </button>
    </div>
  );
}

HardSkillItem.propTypes = {
  hardSkill: PropTypes.shape(HardSkillProp.propType).isRequired,
  onRemove: PropTypes.func.isRequired,
};
